var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useImperativeHandle } from "react";
import { ViewportSizeProvider } from "../ProviderResponsive";
import { showOnSplit } from "../../../shared/Stack/utils";
import '../../../shared/css/Stack.css';
import { useThemeable } from "../ProviderStyleAccess";
export var VStack = forwardRef(function (_a, parentRef) {
    var style = _a.style, maxWidth = _a.maxWidth, children = _a.children, className = _a.className, align = _a.align, showOn = _a.showOn, _b = _a.height, height = _b === void 0 ? 'hug' : _b, _c = _a.width, width = _c === void 0 ? 'fill' : _c, scroll = _a.scroll, _d = _a.group, group = _d === void 0 ? false : _d, setMaxViewSize = _a.setMaxViewSize;
    var localRef = useRef(null);
    useImperativeHandle(parentRef, function () { return localRef.current; });
    var _e = useThemeable(), space = _e.space, spacingMode = _e.spacingMode;
    var combinedClasses = [
        'v-stack',
        className,
        "width-".concat(width),
        "height-".concat(height),
        showOn ? showOnSplit(showOn) : '',
        align,
        scroll && "scroll-".concat(scroll),
    ]
        .filter(Boolean)
        .join(' ');
    var content = (_jsx("div", { ref: localRef, style: __assign({ maxWidth: maxWidth, transition: '.2s', margin: group ? "".concat(space.vExtra, "px ").concat(space.hExtra, "px") : undefined }, style), className: combinedClasses, children: children }));
    if (setMaxViewSize === 'medium' || setMaxViewSize === 'compact' || group) {
        return (_jsx(ViewportSizeProvider, { setSpacingMode: group ? 'grouped' : undefined, setMaxViewSize: setMaxViewSize, children: content }));
    }
    return content;
});
VStack.displayName = 'VStack';
